import React from 'react';
import { jsx } from '@emotion/core';
import moment from 'moment';
import { InsuranceType } from '../../../utils/types';
import DataTable from '../../../components/table/DataTable';
/**@jsx jsx*/

type Actions = { label: string; action: (gender: InsuranceType) => void }[];

interface IProps {
  insuranceTypes?: InsuranceType[];
  actions: Actions;
  isLoading?: boolean;
}

const columns = [
  {
    title: 'Id',
    dataIndex: 'id',
    key: 'id',
  },
  {
    title: 'Name',
    dataIndex: 'name',
    key: 'name',
  },
  {
    title: 'Created At',
    dataIndex: 'createdAt',
    key: 'createdAt',
    render: (createdAt: Date) => {
      return <span>{moment(createdAt).format('DD/MM/YYYY')}</span>;
    },
  },
  {
    title: 'Last Changed',
    dataIndex: 'lastChanged',
    key: 'lastChanged',
    render: (lastChanged: Date) => {
      return <span>{moment(lastChanged).format('DD/MM/YYYY')}</span>;
    },
  },
];

const InsuranceTypesTable: React.FC<IProps> = ({
  insuranceTypes = [],
  actions,
  isLoading,
}) => {
  return (
    <DataTable
      showControls
      showPagination
      data={insuranceTypes}
      columns={columns}
      actions={actions}
      searchFilter="name"
      isLoading={isLoading}
    />
  );
};

export default InsuranceTypesTable;
